import PropTypes from 'prop-types';
import React from 'react';
import Pagination from 'src/common/Pagination/Pagination';

const noop = () => {};

const NotesFooter = ({
  compactBottomSpacing,
  isClientsDrawer,
  page,
  pageSize,
  paging,
  setPageNumber,
  setPageSize,
}) => (
  <>
    {!isClientsDrawer ? (
      <div className={compactBottomSpacing ? 'mb-0' : 'mb-16'}>
        <Pagination
          pageNumber={page}
          pageSize={pageSize}
          scrollPaginationElement={noop}
          totalItemCount={paging.total_count}
          totalPageCount={paging.total_pages}
          setPageSize={setPageSize}
          setPageNumber={setPageNumber}
        />
      </div>
    ) : null}
    {!compactBottomSpacing ? <div className="connector" /> : null}
  </>
);

NotesFooter.propTypes = {
  compactBottomSpacing: PropTypes.bool.isRequired,
  isClientsDrawer: PropTypes.bool.isRequired,
  page: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  paging: PropTypes.object.isRequired,
  setPageNumber: PropTypes.func.isRequired,
  setPageSize: PropTypes.func.isRequired,
};

export default NotesFooter;
